import React from "react";
import { IMAGES, INGREDIENTS } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

export default function Ingredients() {
  useReveal([]);
  return (
    <>
      <PageHero
        tag="La nature marocaine"
        title="Nos <em>Ingrédients</em>"
        subtitle="Sept trésors botaniques récoltés avec respect au cœur du Maroc, pour des soins d'une pureté absolue."
        image={IMAGES.ingredientsHero}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Nos ingrédients" }]} />

      <section className="products-section reveal">
        <div className="feature-grid" style={{ maxWidth: 1100 }}>
          {INGREDIENTS.map((ing) => (
            <div className="feature-card" key={ing.name} data-testid={`ingredient-${ing.name}`}>
              <p className="section-tag" style={{ marginBottom: "0.5rem" }}>{ing.origin}</p>
              <h3>{ing.name}</h3>
              <p>{ing.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
